namespace advisorop.components.widgets {

    export class UserMenuController {
        user: domains.identity.IUser = {};
        userInitials: string = `?`;
        userFullName: string = "";
        userRoles: string = "";
        pictureUrl: string; // = "profile_small.png";
        lastLogin: Date;
        changePasswordLink: string;
        childAdvisors: domains.IUsersHierarchy[];

        static $inject = [`identityService`, `generalService`];
        constructor(
            private ids: services.IdentityService,
            private gs: services.GeneralService,
        ) {
        }


        logout(): void {
            this.ids.logout();
        }

        endImpersonation(): void {
            if (window.confirm(`End Impersonation of current user and get back to your real user account ?`)) {
                // authenticate servicer as advisor 
                this.ids.endImpersonation()
                    .then(response => {
                        // clear localstorage
                        localStorage.clear();
                        // redirect page to advisor dashboard
                        window.location.href = "/";
                    }, err => toastr.error(`Error ${err.status} ${err.data}`))
            }
        }

        impersonateAdvisor(userRelation: domains.IUsersHierarchy) {
            //console.log("Impersonating advisor", userRelation);
            if (confirm(`You are going to impersonate ${userRelation.childUserFullName}. Are you sure?`)) {
                this.ids.impersonateUser(userRelation.childUserName)
                    .then(resp => {
                        localStorage.clear();
                        sessionStorage.clear();
                        // location.reload(true);
                        location.href = "/"; // "/advisor/dashboard";
                    }, err => this.gs.showError(err));
            }
        }

        async loadChildAdvisors() {
            return await this.ids.getChildAdvisors()
                .then(data => {
                    this.childAdvisors = data.data;
                    this.childAdvisors.sort(function (a, b) { return (a.childUserName > b.childUserName) ? 1 : ((b.childUserName > a.childUserName) ? -1 : 0); });
                }, err => this.gs.showError(err));
        }

        async $onInit() {
            var rez = await this.ids.getUserPromise()
                .then(response => {
                    this.user = response;

                    this.userFullName = this.user.firstName + " " + this.user.lastName;

                    this.userRoles = this.user.role;

                    this.pictureUrl = this.user.pictureUrl; // ? this.user.pictureUrl : "profile.jpg";

                    this.lastLogin = this.user.lastLogin;

                    this.userInitials = this.user.firstName[0];

                    if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
                        this.changePasswordLink = `/servicer/userprofile`;
                    } else if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
                        this.changePasswordLink = `/advisor/userprofile`;
                    } else if (this.user.systemLoginType == domains.SystemLoginType.INVESTOR) {
                        this.changePasswordLink = `/investor/userprofile`;
                    }
                });

            if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
                this.loadChildAdvisors();
            }

            return rez;
        }

        $routerOnActivate(next, previous) {
        }
    }


    class UserMenu implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
            };
            this.controller = UserMenuController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/user-menu.html';
        }
    }
    angular.module(Constants.APP).component("userMenu", new UserMenu());
}